import React, { useEffect, useState } from 'react';
import { useWizard } from '../../Contexts/WizardContext';
import { AddressAutocomplete } from '../General/AddressAutocomplete';
import { Button } from '../General/Button';
import { getJobsiteData } from '../../api/endpoints';
import Loader from '../General/Loader';

export default function AddressInputNew() {
  const { updateFormData, nextStep, formData } = useWizard();

  const [address, setAddress] = useState(formData?.address || null)
  const [isError, setIsError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [isContinueButtonDisabled, setBlockButton] = useState(true)

  const [isDataLoading, setIsDataLoading] = useState(false)

  useEffect(() => {
    setBlockButton(false)
    setErrorMessage('')
    setIsError(false)
  }, [address])

  const handleSubmit = async () => {
    const isValidated = validateAdd(address.addressComponents)
    if (isValidated) {
      setBlockButton(true)
      setIsDataLoading(true)
        const jobsiteData = await getJobsiteData(address)
        if (jobsiteData.is_in_service_area) {
          updateFormData(oldVal => {
            return {
                ...oldVal,
                address: {...address},
                jobsiteData: {...jobsiteData}
            }
          })
          nextStep()
        } else {
          setIsDataLoading(false)
          setIsError(true)
          setErrorMessage('Unfortunately, address is not in our service area.')
        }
    } else {
      setBlockButton(true)
    }
  }

  const validateAdd = (addressComponents) => {
    let validated = true, message = ''
    if (!addressComponents.street_number || !addressComponents.postal_code) {
        validated = false
        message = 'There is no street number or postal code in provided address.'
    }
    if (addressComponents.state.toLowerCase() != 'co') {
        validated = false
        message = 'Provided address is not in CO.'
    }
    setIsError(!validated)
    setErrorMessage(message)
    return validated
  }

  return (
    <div className="w-full max-w-2xl mx-auto p-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
          Service Location
        </h2>
        <p className="text-gray-600">Where would you like us to provide service?</p>
      </div>
      <Loader isLoading={isDataLoading} >
        <div className="space-y-6">
          <div id="address-container" style={{ position: 'relative', zIndex: 9999, isolation: 'isolate' }}>
            <AddressAutocomplete
              typeVariant="default"
              error={isError ? errorMessage : ''}
              size="sm"
              label="Street Address"
              required
              customClassnames={{
                  container: "gap-0",
              }}
              address={address}
              name="NAME OF INPUT"
              customCallback={setAddress}
              // onPlaceSelect={setAddress}
              />

          </div>

          <div className="flex justify-center">
              <Button
                  label='Continue'
                  isDisabled={isContinueButtonDisabled}
                  onClick={handleSubmit}
                  primary
              />
          </div>
        </div>
      </Loader>
    </div>
  );
};
